<ng-container [ngSwitch]="type">
  <mat-icon
    *ngSwitchCase="EaIconType.MATERIAL"
    [tooltip]="tooltip"
    [ngStyle]="{
      'font-size': width + 'px',
      width: width + 'px',
      height: width + 'px',
    }"
    [style.height]="height || width + 'px'"
    >{{ icon }}</mat-icon
  >
  <svg-icon-sprite
    *ngSwitchCase="EaIconType.SPRITE"
    src="{{ 'assets/svg/sprite.svg#' + icon }}"
    [tooltip]="tooltip"
    [width]="width + 'px'"
    [height]="height || width + 'px'"
    [viewBox]="'0 0 ' + viewBoxWidth + ' ' + viewBoxHeight"
  >
  </svg-icon-sprite>
  <svg-icon-sprite
    *ngSwitchCase="EaIconType.FLAGSPRITE"
    src="{{ 'assets/svg/flags-sprite.svg#' + icon }}"
    [tooltip]="tooltip"
    [width]="width + 'px'"
    [height]="height || 16 + 'px'"
    [viewBox]="'0 0 512 512'"
    preserveAspectRatio="none"
    class="flag-icon"
  >
  </svg-icon-sprite>
  <i
    *ngSwitchCase="EaIconType.FONTAWESOME"
    [tooltip]="tooltip"
    aria-hidden="true"
    class="{{ 'fa ' + icon }}"
    [ngStyle]="{
      'font-size': width + 'px',
      width: width + 'px',
      height: height || width + 'px',
    }"
  ></i>
  <ng-content></ng-content>
</ng-container>
